export class LocalizationApi  {
    async getLocalizations(): Promise<{ [key: string]: string }> {
        let mockedLocalizations : { [key: string]: string }  = {};
        mockedLocalizations["login"] = "Log ind";

        return mockedLocalizations;
    }
}
